<template>
  <div
    class="designer-section"
    :class="{'selected':section.$selected}"
  >
    <header>
      <button class="drag-handler">
        <i class="icon-drag_handle"/>
      </button>

      <h1><span class="index">{{ currentIndex }}</span>{{ name }}</h1>

      <div class="button-wrapper">
        <button
          @click="$emit('select', section)"
        >
          <i class="icon-mode_edit"/>
        </button>
        <button
          @click="$emit('delete', index)"
        >
          <i class="icon-delete"/>
        </button>
        <button
          class="btn-expand"
          @click="toggle"
        >
          <i class="icon-expand_more"/>
        </button>
      </div>

    </header>
    <main :class="{closed:section.$collapsed}">
      <div
        v-if="section.description"
        class="description"
        v-html="section.description"
      />
      <slot/>
    </main>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'DesignerSection',
  props: {
    index: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    section: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isOpen: true
    }
  },
  computed: {
    currentIndex () {
      let result = ''
      for (let i = 0; i < this.index.length; i++) {
        result += this.index[i] + 1 + '.'
      }
      return result.slice(0, -1)
    },
    name () {
      return this.section.name || 'Sección sin nombre'
    }
  },
  methods: {
    toggle () {
      this.section.$collapsed = !this.section.$collapsed
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.designer-section {
  border: 1px solid #dddddd;
  margin: 20px;
  padding-top: 0;
  padding-bottom: 20px;
  transition: all 0.3s ease-in-out;
  .designer-section {
    margin-top: 0;
    header {
      .col {
        h1 {
          @include font-primary(14px, regular);
          .index {
            @include font-primary(14px, bold);
          }
        }
      }
    }
  }
  &.selected {
    border: 1px solid red;
    background-color: #f2f2f2;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    h1 {
      .index {
        background-color: $color-ui-primary;
        color: #fff;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
      }
    }
    .designer-section {
      h1 {
        .index {
          color: #fff;
        }
      }
    }
  }
  header {
    height: 55px;
    position: relative;
    overflow: hidden;
    h1 {
      font-size: 14px;
      margin-top: 20px;
      margin-left: 55px;
      @include font-primary(16px, regular);
      .index {
        @include font-primary(12px, bold);
        display: inline-block;
        background-color: $color-ui-primary;
        color: #fff;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
        padding: 5px;
        min-width: 14px;
        text-align: center;
        border-radius: 2px;
        margin-right: 20px;
      }
    }

    .drag-handler {
      background-color: transparent;
      border: none;
      width: 55px;
      height: 55px;
      padding: 0;
      margin: 0;
      position: absolute;
      top: 0;
      left: 0;
      &:active {
        color: #333333;
      }
      &:focus {
        outline: none;
      }
      &:hover {
        cursor: grab;
      }
      &:active {
        cursor: grabbing;
      }
      .icon-drag_handle {
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        pointer-events: none;
        font-size: 18px;
        user-select: none;
        border: 1px solid transparent;
        &::before {
          vertical-align: middle;
        }
      }
    }
    .button-wrapper {
      position: absolute;
      right: 0;
      top: 0;
      button {
        display: inline-block;
        width: 40px;
        height: 40px;
        background-color: transparent;
        border: none;
        color: #999999;
        &:hover {
          color: #666666;
        }
        &:focus {
          outline: none;
          box-shadow: none;
        }
        &.btn-expand {
        }
      }
    }
  }
  main {
    overflow: hidden;
    max-height: 3333px;
    transition: all 0.3s ease-in-out;
    &.closed {
      max-height: 0;
    }
    .description {
      padding-bottom: 20px;
      padding-right: 80px;
      margin-left: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/_shared/designer-section.vue